import { useCallback } from "react";

import API from "./API";
import { useRecurringGifts } from "./RecurringGiftsContext";

export function useFetchUserRecurringGifts() {
  const { dispatch } = useRecurringGifts();

  return useCallback(
    (userID) => {
      if (!userID) return;

      dispatch({
        type: "setRecurringGiftListStatus",
        payload: "loading",
      });

      API.getRecurringGifts({ userID })
        .post()
        .then((res) => {
          res.profileUserID = userID;
          dispatch({
            type: "handleGetRecurringGiftsResponse",
            payload: res,
          });

          dispatch({
            type: "setRecurringGiftListStatus",
            payload: "success",
          });
        })
        .catch(() => {
          dispatch({
            type: "setRecurringGiftListStatus",
            payload: "error",
          });
        });
    },
    [dispatch]
  );
}
